/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

var Flickity = require('flickity');
require('flickity-imagesloaded');

require('../vendor/magnific.js');

import './parallax.js';
import { parallax } from './parallax.js';

// =============================================================================
// Values Slider
// =============================================================================
export function valuesSlider() {
  const valuesSliderEl = document.querySelector('.values__slider');

  if(window.matchMedia("(max-width: 1199.98px)").matches) {
    const flkty = new Flickity( valuesSliderEl, {
      // options
      // cellAlign: 'left',
      contain: true,
      imagesLoaded: true,
      wrapAround: false,
      adaptiveHeight: false,
      prevNextButtons: true,
      pageDots: false,
      // groupCells: 2,
      draggable: true,
      on: {
        ready: function () {
          setTimeout(() => {
            flkty.resize();
          }, 2000);
        },
      }
    })
  }

  var tapArea, startX ;
  tapArea = document.querySelectorAll('.values__slider');
  startX = 0;

  for (var item of tapArea) {
    item.addEventListener('mousedown', function(e) {
      startX = e.clientX;
    })
    item.addEventListener('mousemove', function(e) {
      if (Math.abs(e.clientX - startX) > 5 && e.cancelable ) {
        e.preventDefault();
      }
    })
  }
}
